import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { ToasterService } from '../../../shared/toaster/toaster.service';
import { AuthService } from '../../../services/shared/auth.service';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
@Component({
  selector: 'app-register',
  standalone: true,
  imports: [FormsModule, HttpClientModule,SpinnerComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  constructor(
    private router: Router,
    private toasterService: ToasterService,
    private authService: AuthService
  ) { }

  form = {
    originalName: '',
    username: '',
    password: '',
    gender: '',
    location: { latitude: 0, longitude: 0 }
  };

  otp: string = '';
  showOtpModal: boolean = false;
  isOtpSent = false;
  isSubmitting = false;
   spinner: boolean = false;
  spinMessage: string = '';


async onRegister() {

  if (!this.form.originalName?.trim()) {
    this.toasterService.showToast('Please enter your name', 'warning');
    return;
  }

  if (!this.form.username?.trim()) {
    this.toasterService.showToast('Please enter username', 'warning');
    return;
  }

  if (!this.form.password?.trim()) {
    this.toasterService.showToast('Please enter password', 'warning');
    return;
  }

  if (!this.form.gender) {
    this.toasterService.showToast('Please select gender', 'warning');
    return;
  }

  try {
    this.spinner = true;
    this.spinMessage = 'Getting your location...';

    await this.getUserLocation();

    this.spinMessage = 'Creating your account...';

    const res: any = await this.authService.register(this.form).toPromise();

    this.toasterService.showToast(
      res.message || 'Registration successful ✅',
      'success'
    );

    this.playSound();
    this.router.navigate(['/']);

  } catch (error: any) {
    const msg = error?.error?.error || 'Registration failed ❌';
    this.toasterService.showToast(msg, 'error');
  } finally {
    this.spinner = false;
    this.spinMessage = '';
  }
}


// async submitOtp() {
//   if (this.otp.length === 6) {
//     try {
//       this.spinner = true;
//       this.spinMessage = 'Verifying OTP...';

//       const body = {
//         ...this.form,
//         otp: this.otp
//       };

//       await this.authService.verifyOtpRegister(body).toPromise();

//       this.toasterService.showToast('🎉 OTP verified! Registration successful.', 'success');
//       this.router.navigate(['/']);
//     } catch (error: any) {
//       const msg = error?.error?.error || 'An error occurred ❌';
//       const attemptsLeft = error?.error?.attemptsLeft;

//       if (error.status === 429) {
//         this.toasterService.showToast(`🚫 ${msg}`, 'error');
//       } else if (error.status === 400 && attemptsLeft !== undefined) {
//         this.toasterService.showToast(`❌ ${msg} | Attempts left: ${attemptsLeft}`, 'error');
//       } else {
//         this.toasterService.showToast(msg, 'error');
//       }
//     } finally {
//       this.spinner = false;
//       this.spinMessage = '';
//     }
//   } else {
//     this.toasterService.showToast('Please enter a valid 6-digit OTP', 'warning');
//   }
// }


  // getUserLocation(): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     if (!navigator.geolocation) {
  //       this.toasterService.showToast('Geolocation is not supported', 'error');
  //       return reject();
  //     }

  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         this.form.location.latitude = position.coords.latitude;
  //         this.form.location.longitude = position.coords.longitude;
  //         resolve();
  //       },
  //       (error) => {
  //         this.toasterService.showToast('Failed to get location', 'error');
  //         reject(error);
  //       }
  //     );
  //   });
  // }

  getUserLocation(): Promise<void> {
  this.spinner = true;
  this.spinMessage = 'Getting your location...';

  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      this.toasterService.showToast('Geolocation is not supported', 'error');
      this.spinner = false;
      this.spinMessage = '';
      return reject();
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.form.location.latitude = position.coords.latitude;
        this.form.location.longitude = position.coords.longitude;
        this.spinner = false;
        this.spinMessage = '';
        resolve();
      },
      (error) => {
        this.toasterService.showToast('Failed to get location', 'error');
        this.spinner = false;
        this.spinMessage = '';
        reject(error);
      }
    );
  });
}


  playSound() {
    const audio = new Audio('assets/sounds/reg.mp3');
    audio.play();
  }

  login() {
    this.router.navigate(['/']);
  }
}
